// import React, { useState, useEffect } from 'react';
// import { Search, Loader2, Eye, X, BookOpen, Calendar, User, Phone, CheckCircle, FileText, Download } from 'lucide-react';
// import * as XLSX from 'xlsx';


// export default function ExamApplicationsList() {
//   const [dataList, setDataList] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [tableLoading, setTableLoading] = useState(false);
//   const [selectedApp, setSelectedApp] = useState(null); // For detail view modal

//   // Pagination Parameters
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 8;

//   useEffect(() => {
//     fetchApplications();
//   }, [searchTerm]);

//   const fetchApplications = async () => {
//     setTableLoading(true);
//     try {
//       const res = await fetch(
//         `https://metapi.emedhatechnologies.com/api/exams/exam-applications?search=${encodeURIComponent(searchTerm)}`
//       );
//       const result = await res.json();
//       if (result.success) setDataList(result.data);
//       else setDataList([]);
//     } catch (err) {
//       console.error('Failed to load applications:', err);
//       setDataList([]);
//     } finally {
//       setTableLoading(false);
//     }
//   };

//   // Pagination Window Range Computation
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = dataList.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(dataList.length / itemsPerPage);

//   const formatDate = (dateStr) => {
//     if (!dateStr) return '-';
//     const d = new Date(dateStr);
//     return isNaN(d.getTime()) ? dateStr : d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
//   };


//   const handleExportToExcel = () => {
//   if (dataList.length === 0) {
//     alert("No examination application records available to export.");
//     return;
//   }

//   const exportData = dataList.map((item, index) => ({
//     "S.No": index + 1,
//     "Application ID": `#${item.id}`,
//     "Enrolment Number": item.enrolment_number || 'N/A',
//     "Applicant Name": item.student_name || 'N/A',
//     "Mobile Number": item.mobile_number || 'N/A',
//     "Father Name": item.father_name || 'N/A',
//     "Gender": item.gender || 'N/A',
//     "DOB": item.dob || 'N/A',
//     "Course Track": item.course_name || 'N/A',
//     "Appearing Term/Semester": item.appearing_semester || 'Semester 1',
//     "Exam Session": item.exam_month_year || 'N/A',
//     "No of Papers": item.no_of_papers_appeared || (item.subjects_list ? item.subjects_list.length : 0),
//     "Fee Paid (INR)": parseFloat(item.amount_paid || 0),
//     "Application Status": item.status || 'Submitted',
//     "Study / Exam Centre": item.study_centre_name || 'ALAGAPPA UNIVERSITY',
//     "Applied Date": item.created_at ? new Date(item.created_at).toLocaleDateString('en-IN') : 'N/A'
//   }));

//   const worksheet = XLSX.utils.json_to_sheet(exportData);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Exam_Applications");

//   const fileName = `Exam_Applications_Report_${new Date().toISOString().substring(0, 10)}.xlsx`;
//   XLSX.writeFile(workbook, fileName);
// };



//   return (
//     <div style={styles.container}>
//       {/* STEP 1: TOP HEADER & SEARCH FILTER BAR */}
//    {/* STEP 1: TOP HEADER & SEARCH FILTER BAR */}
// <div style={styles.filterControlPanel}>
//   <div style={styles.searchWrapper}>
//     <Search size={16} style={styles.searchIcon} />
//     <input
//       type="text"
//       placeholder="Search by student name, enrollment no, course, mobile..."
//       value={searchTerm}
//       onChange={(e) => {
//         setSearchTerm(e.target.value);
//         setCurrentPage(1);
//       }}
//       style={styles.tableSearchInput}
//     />
//   </div>

//   <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
//     <button
//       type="button"
//       onClick={handleExportToExcel}
//       style={styles.exportExcelBtn}
//       title="Export all filtered examination applications to Excel"
//     >
//       <Download size={14} /> Export Excel
//     </button>

//     <div style={styles.totalIndicator}>
//       Total Applications: <strong style={{ color: '#1c6ec9' }}>{dataList.length}</strong>
//     </div>
//   </div>
// </div>

//       {/* STEP 2: DATA TABLE */}
//       {tableLoading ? (
//         <div style={{ display: 'flex', justifyContent: 'center', padding: '60px' }}>
//           <Loader2 size={32} style={{ animation: 'spin 1s linear infinite' }} color="#1c6ec9" />
//         </div>
//       ) : (
//         <div style={{ overflowX: 'auto', width: '100%', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
//           <table style={styles.dataTable}>
//             <thead>
//               <tr>
//                 <th style={styles.tableTh}>Enrolment No</th>
//                 <th style={styles.tableTh}>Applicant Name</th>
//                 <th style={styles.tableTh}>Course Track</th>
//                 <th style={styles.tableTh}>Term / Sem</th>
//                 <th style={styles.tableTh}>Exam Session</th>
//                 <th style={styles.tableTh}>Papers</th>
//                 <th style={styles.tableTh}>Amount</th>
//                 <th style={styles.tableTh}>Status</th>
//                 <th style={styles.tableTh}>Applied Date</th>
//                 <th style={styles.tableTh}>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {dataList.length === 0 ? (
//                 <tr>
//                   <td colSpan="10" style={styles.noDataTd}>
//                     No examination applications found matching your criteria.
//                   </td>
//                 </tr>
//               ) : (
//                 currentItems.map((item) => (
//                   <tr key={item.id} style={styles.tableTr}>
//                     <td style={{ ...styles.tableTd, fontWeight: '700', color: '#1e40af' }}>
//                       {item.enrolment_number}
//                     </td>
//                     <td style={{ ...styles.tableTd, fontWeight: '700', color: '#0f172a' }}>
//                       {item.student_name}
//                       <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '500' }}>
//                         {item.mobile_number}
//                       </div>
//                     </td>
//                     <td style={{ ...styles.tableTd, color: '#334155', fontWeight: '600' }}>
//                       {item.course_name}
//                     </td>
//                     <td style={styles.tableTd}>
//                       <span style={styles.termLabel}>{item.appearing_semester || 'Semester 1'}</span>
//                     </td>
//                     <td style={{ ...styles.tableTd, color: '#475569', fontSize: '12.5px' }}>
//                       {item.exam_month_year}
//                     </td>
//                     <td style={{ ...styles.tableTd, textAlign: 'center', fontWeight: '700' }}>
//                       {item.no_of_papers_appeared || (item.subjects_list ? item.subjects_list.length : 0)}
//                     </td>
//                     <td style={{ ...styles.tableTd, fontWeight: '700', color: '#059669' }}>
//                       ₹{parseFloat(item.amount_paid || 0).toLocaleString('en-IN')}
//                     </td>
//                     <td style={styles.tableTd}>
//                       <span
//                         style={{
//                           ...styles.statusPill,
//                           ...(item.status === 'Approved'
//                             ? styles.statusApproved
//                             : item.status === 'Rejected'
//                             ? styles.statusRejected
//                             : styles.statusSubmitted),
//                         }}
//                       >
//                         {item.status || 'Submitted'}
//                       </span>
//                     </td>
//                     <td style={{ ...styles.tableTd, fontSize: '12px', color: '#64748b' }}>
//                       {formatDate(item.created_at)}
//                     </td>
//                     <td style={styles.tableTd}>
//                       <button
//                         onClick={() => setSelectedApp(item)}
//                         style={styles.viewRowBtn}
//                         title="View Full Application"
//                       >
//                         <Eye size={13} style={{ marginRight: '4px' }} /> View
//                       </button>
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* STEP 3: PAGINATION */}
//       {dataList.length > 0 && (
//         <div style={styles.paginationDock}>
//           <button
//             disabled={currentPage === 1}
//             onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//             style={currentPage === 1 ? { ...styles.pageBtn, ...styles.pageBtnDisabled } : styles.pageBtn}
//           >
//             Previous
//           </button>
//           <span style={styles.pageIndicator}>
//             Page <strong>{currentPage}</strong> of {totalPages || 1}
//           </span>
//           <button
//             disabled={currentPage === totalPages || totalPages === 0}
//             onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
//             style={
//               currentPage === totalPages || totalPages === 0
//                 ? { ...styles.pageBtn, ...styles.pageBtnDisabled }
//                 : styles.pageBtn
//             }
//           >
//             Next
//           </button>
//         </div>
//       )}

//       {/* STEP 4: DETAILED APPLICANT VIEW MODAL */}
//       {selectedApp && (
//         <div style={styles.modalBackdrop}>
//           <div style={styles.modalWrapperCard}>
//             <div style={styles.modalHeader}>
//               <div>
//                 <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '800', color: '#0f172a' }}>
//                   Examination Application Details
//                 </h3>
//                 <span style={{ fontSize: '12px', color: '#64748b' }}>
//                   Application ID: #{selectedApp.id} • {formatDate(selectedApp.created_at)}
//                 </span>
//               </div>
//               <button onClick={() => setSelectedApp(null)} style={styles.modalCloseX}>
//                 <X size={18} />
//               </button>
//             </div>

//             <div style={styles.modalBodyScroll}>
//               {/* Top Banner Details */}
//               <div style={styles.applicantInfoBanner}>
//                 <div style={styles.infoCol}>
//                   <span style={styles.infoLabel}>Applicant Name</span>
//                   <span style={styles.infoValue}>{selectedApp.student_name}</span>
//                 </div>
//                 <div style={styles.infoCol}>
//                   <span style={styles.infoLabel}>Enrolment Number</span>
//                   <span style={{ ...styles.infoValue, color: '#1e40af' }}>{selectedApp.enrolment_number}</span>
//                 </div>
//                 <div style={styles.infoCol}>
//                   <span style={styles.infoLabel}>Gender / DOB</span>
//                   <span style={styles.infoValue}>{selectedApp.gender || '-'} / {selectedApp.dob || '-'}</span>
//                 </div>
//                 <div style={styles.infoCol}>
//                   <span style={styles.infoLabel}>Father's Name</span>
//                   <span style={styles.infoValue}>{selectedApp.father_name || '-'}</span>
//                 </div>
//                 <div style={styles.infoCol}>
//                   <span style={styles.infoLabel}>Mobile / WhatsApp</span>
//                   <span style={styles.infoValue}>{selectedApp.mobile_number}</span>
//                 </div>
//                 <div style={styles.infoCol}>
//                   <span style={styles.infoLabel}>Study / Exam Centre</span>
//                   <span style={styles.infoValue}>{selectedApp.study_centre_name || 'ALAGAPPA UNIVERSITY'}</span>
//                 </div>
//               </div>

//               {/* Course & Term Bar */}
//               <div style={styles.courseMetaBar}>
//                 <div>
//                   <span style={{ fontSize: '11px', color: '#64748b', textTransform: 'uppercase', fontWeight: '700' }}>Course Track</span>
//                   <div style={{ fontSize: '14px', fontWeight: '800', color: '#0f172a' }}>{selectedApp.course_name}</div>
//                 </div>
//                 <div style={{ textAlign: 'right' }}>
//                   <span style={{ fontSize: '11px', color: '#64748b', textTransform: 'uppercase', fontWeight: '700' }}>Term & Session</span>
//                   <div style={{ fontSize: '13px', fontWeight: '700', color: '#1e40af' }}>
//                     {selectedApp.appearing_semester} ({selectedApp.exam_month_year})
//                   </div>
//                 </div>
//               </div>

//               {/* Address */}
//               {selectedApp.permanent_address ? (
//                 <div style={styles.addressBox}>
//                   <span style={styles.infoLabel}>Permanent Address</span>
//                   <div style={{ fontSize: '12.5px', color: '#334155', marginTop: '2px' }}>
//                     {selectedApp.permanent_address}
//                   </div>
//                 </div>
//               ) : null}

//               {/* Subjects Table */}
//               <div style={{ marginTop: '16px' }}>
//                 <span style={{ fontSize: '12px', fontWeight: '800', color: '#0f172a', textTransform: 'uppercase' }}>
//                   Applied Subjects ({selectedApp.subjects_list ? selectedApp.subjects_list.length : 0} Papers)
//                 </span>
//                 <div style={styles.subjectsTableWrapper}>
//                   <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                     <thead>
//                       <tr style={{ background: '#f1f5f9' }}>
//                         <th style={{ ...styles.subTh, width: '90px' }}>Sub Code</th>
//                         <th style={styles.subTh}>Title of the Course</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {!selectedApp.subjects_list || selectedApp.subjects_list.length === 0 ? (
//                         <tr>
//                           <td colSpan="2" style={{ padding: '12px', textAlign: 'center', color: '#94a3b8', fontSize: '12px' }}>
//                             No specific subject list provided.
//                           </td>
//                         </tr>
//                       ) : (
//                         selectedApp.subjects_list.map((sub, idx) => (
//                           <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
//                             <td style={{ padding: '8px 12px', fontWeight: '700', color: '#2563eb', fontSize: '12.5px' }}>
//                               {sub.code}
//                             </td>
//                             <td style={{ padding: '8px 12px', color: '#334155', fontSize: '12.5px' }}>
//                               {sub.title}
//                             </td>
//                           </tr>
//                         ))
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>

//               {/* Payment Summary */}
//               <div style={styles.paymentSummaryRow}>
//                 <div>
//                   <span style={{ fontSize: '11px', color: '#64748b' }}>Total Fee Paid:</span>
//                   <div style={{ fontSize: '18px', fontWeight: '900', color: '#059669' }}>
//                     ₹{parseFloat(selectedApp.amount_paid || 0).toLocaleString('en-IN')}
//                   </div>
//                 </div>
//                 <button onClick={() => setSelectedApp(null)} style={styles.modalCloseBtn}>
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// // STYLES MATRIX
// const styles = {
//   container: { width: '100%', boxSizing: 'border-box' },
//   filterControlPanel: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     gap: '16px',
//     marginBottom: '16px',
//     flexWrap: 'wrap',
//   },
//   searchWrapper: {
//     position: 'relative',
//     display: 'flex',
//     alignItems: 'center',
//     flex: 1,
//     maxWidth: '420px',
//     width: '100%',
//   },
//   searchIcon: { position: 'absolute', left: '12px', color: '#94a3b8' },
//   tableSearchInput: {
//     width: '100%',
//     padding: '10px 12px 10px 38px',
//     background: '#ffffff',
//     border: '1px solid #e2e8f0',
//     borderRadius: '10px',
//     color: '#0f172a',
//     fontSize: '13.5px',
//     outline: 'none',
//     boxShadow: '0 1px 2px rgba(0,0,0,0.02)',
//   },
//   totalIndicator: { fontSize: '13.5px', fontWeight: '600', color: '#475569' },
//   dataTable: { width: '100%', borderCollapse: 'collapse', textAlign: 'left', background: '#ffffff' },
//   tableTh: {
//     padding: '12px 14px',
//     borderBottom: '2px solid #e2e8f0',
//     background: '#f8fafc',
//     color: '#64748b',
//     fontSize: '11px',
//     textTransform: 'uppercase',
//     letterSpacing: '0.5px',
//     fontWeight: '700',
//     whiteSpace: 'nowrap',
//   },
//   tableTr: { borderBottom: '1px solid #f1f5f9' },
//   tableTd: { padding: '13px 14px', color: '#475569', fontSize: '13px', verticalAlign: 'middle', whiteSpace: 'nowrap' },
//   noDataTd: { padding: '40px 14px', textAlign: 'center', color: '#94a3b8', fontSize: '14px', fontWeight: '500' },
//   termLabel: {
//     background: '#eff6ff',
//     border: '1px solid #bfdbfe',
//     color: '#1e40af',
//     padding: '3px 8px',
//     borderRadius: '6px',
//     fontSize: '11.5px',
//     fontWeight: '700',
//   },
//   statusPill: { padding: '4px 10px', borderRadius: '12px', fontSize: '11px', fontWeight: '700', display: 'inline-block' },
//   statusSubmitted: { background: '#fef3c7', color: '#92400e' },
//   statusApproved: { background: '#d1fae5', color: '#065f46' },
//   statusRejected: { background: '#fee2e2', color: '#991b1b' },
//   viewRowBtn: {
//     display: 'inline-flex',
//     alignItems: 'center',
//     background: '#eff6ff',
//     border: '1px solid #bfdbfe',
//     color: '#1d4ed8',
//     padding: '5px 10px',
//     borderRadius: '6px',
//     fontSize: '12px',
//     fontWeight: '700',
//     cursor: 'pointer',
//   },
//   paginationDock: {
//     display: 'flex',
//     justifyContent: 'flex-end',
//     alignItems: 'center',
//     gap: '12px',
//     marginTop: '16px',
//     paddingTop: '12px',
//     borderTop: '1px solid #edf2f7',
//   },
//   pageIndicator: { fontSize: '13px', color: '#475569' },
//   pageBtn: {
//     background: '#ffffff',
//     border: '1px solid #e2e8f0',
//     borderRadius: '6px',
//     padding: '6px 14px',
//     color: '#334155',
//     fontSize: '12.5px',
//     fontWeight: '600',
//     cursor: 'pointer',
//     transition: 'all 0.2s',
//   },
//   pageBtnDisabled: { background: '#f8fafc', color: '#94a3b8', cursor: 'not-allowed', borderColor: '#e2e8f0' },
//   modalBackdrop: {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     background: 'rgba(15, 23, 42, 0.4)',
//     backdropFilter: 'blur(6px)',
//     zIndex: 2000,
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     padding: '20px',
//   },
//   modalWrapperCard: {
//     background: '#ffffff',
//     borderRadius: '20px',
//     width: '100%',
//     maxWidth: '650px',
//     maxHeight: '90vh',
//     padding: '24px',
//     display: 'flex',
//     flexDirection: 'column',
//     boxSizing: 'border-box',
//     boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.15)',
//   },
//   modalHeader: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'flex-start',
//     paddingBottom: '14px',
//     borderBottom: '1px solid #e2e8f0',
//   },
//   modalCloseX: { background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer' },
//   modalBodyScroll: { overflowY: 'auto', marginTop: '14px', paddingRight: '4px' },
//   applicantInfoBanner: {
//     display: 'grid',
//     gridTemplateColumns: '1fr 1fr',
//     gap: '12px',
//     background: '#f8fafc',
//     borderRadius: '12px',
//     padding: '14px',
//     border: '1px solid #e2e8f0',
//   },
//   exportExcelBtn: {
//   background: '#0f172a',
//   color: '#ffffff',
//   border: 'none',
//   padding: '8px 16px',
//   borderRadius: '8px',
//   fontSize: '12.5px',
//   fontWeight: '700',
//   cursor: 'pointer',
//   display: 'inline-flex',
//   alignItems: 'center',
//   gap: '6px',
//   boxShadow: '0 2px 4px rgba(15, 23, 42, 0.1)',
//   transition: 'all 0.2s ease',
// },
//   infoCol: { display: 'flex', flexDirection: 'column' },
//   infoLabel: { fontSize: '11px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase' },
//   infoValue: { fontSize: '13px', fontWeight: '700', color: '#0f172a', marginTop: '2px' },
//   courseMetaBar: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     background: '#eff6ff',
//     border: '1px solid #bfdbfe',
//     borderRadius: '12px',
//     padding: '12px 14px',
//     marginTop: '12px',
//   },
//   addressBox: {
//     background: '#ffffff',
//     borderRadius: '10px',
//     padding: '12px',
//     border: '1px solid #e2e8f0',
//     marginTop: '12px',
//   },
//   subjectsTableWrapper: {
//     border: '1px solid #e2e8f0',
//     borderRadius: '8px',
//     overflow: 'hidden',
//     marginTop: '8px',
//   },
//   subTh: { padding: '8px 12px', textAlign: 'left', fontSize: '11px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase' },
//   paymentSummaryRow: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginTop: '20px',
//     paddingTop: '14px',
//     borderTop: '1px solid #e2e8f0',
//   },
//   modalCloseBtn: {
//     background: '#2563eb',
//     border: 'none',
//     color: '#ffffff',
//     padding: '8px 18px',
//     borderRadius: '8px',
//     fontSize: '13px',
//     fontWeight: '700',
//     cursor: 'pointer',
//   },
// };

import React, { useState, useEffect } from 'react';
import { 
  Search, 
  Loader2, 
  Eye, 
  X, 
  BookOpen, 
  Calendar, 
  User, 
  Phone, 
  CheckCircle, 
  FileText, 
  Download, 
  Plus, 
  Edit3, 
  Trash2, 
  CheckSquare, 
  Square,
  Printer 
} from 'lucide-react';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';

export default function ExamApplicationsList() {
  const [dataList, setDataList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [tableLoading, setTableLoading] = useState(false);
  const [selectedApp, setSelectedApp] = useState(null); // Detail View Modal

  // Create / Edit Modal States
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  // Master Reference Data
  const [studentsList, setStudentsList] = useState([]);
  const [masterCoursesData, setMasterCoursesData] = useState([]);
  const [availableSemesters, setAvailableSemesters] = useState([]);
  const [allAvailablePapers, setAllAvailablePapers] = useState([]);

  // Form Fields State
  const [formStudentId, setFormStudentId] = useState('');
  const [formStudentName, setFormStudentName] = useState('');
  const [formFatherName, setFormFatherName] = useState('');
  const [formGender, setFormGender] = useState('Male');
  const [formEnrolmentNo, setFormEnrolmentNo] = useState('');
  const [formUniversityAdmNo, setFormUniversityAdmNo] = useState('');
  const [formDob, setFormDob] = useState('');
  const [formAddress, setFormAddress] = useState('');
  const [formMobile, setFormMobile] = useState('');
  const [formWhatsapp, setFormWhatsapp] = useState('');
  const [formCourseName, setFormCourseName] = useState('');
  const [formCourseId, setFormCourseId] = useState(0);
  const [formStudyCentre, setFormStudyCentre] = useState('ALAGAPPA UNIVERSITY');
  const [formExamCentre, setFormExamCentre] = useState('ALAGAPPA UNIVERSITY');
  const [formExamMonthYear, setExamMonthYear] = useState('Dec 2026');
  const [formStatus, setFormStatus] = useState('Submitted');
  const [selectedSemesters, setSelectedSemesters] = useState(['Semester 1']);
  const [selectedPaperCodes, setSelectedPaperCodes] = useState([]);


  const [studentPickerSearch, setStudentPickerSearch] = useState('');
const [isPickerDropdownOpen, setIsPickerDropdownOpen] = useState(false);

const [studentEnrolledCourses, setStudentEnrolledCourses] = useState([]);



  // Pagination Parameters
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  useEffect(() => {
    fetchApplications();
  }, [searchTerm]);

  useEffect(() => {
    fetchMasterData();
  }, []);


  const filteredCandidateList = studentsList.filter((s) => {
  const term = studentPickerSearch.toLowerCase();
  const name = (s.name || '').toLowerCase();
  const mobile = (s.mobile || '').toLowerCase();
  const email = (s.email || '').toLowerCase();
  const adm = (s.adm_number || s.roll_number || '').toLowerCase();
  const course = (s.target_course || '').toLowerCase();

  return name.includes(term) || mobile.includes(term) || email.includes(term) || adm.includes(term) || course.includes(term);
});



// Helper to find master course by exact name match

const getMasterCourseByName = (courseName) => {
  if (!courseName) return null;
  const clean = courseName.trim().toLowerCase();
  return masterCoursesData.find(
    (c) => (c.course_name || '').trim().toLowerCase() === clean
  ) || null;
};

const handleSelectCandidate = (candidate) => {
  setFormStudentId(candidate.id);
  setFormStudentName(candidate.name || '');
  setFormFatherName(candidate.father_name || '');
  setFormGender(candidate.gender || 'Male');
  setFormEnrolmentNo(candidate.roll_number || candidate.adm_number || `MET-ADM-${candidate.id}`);
  setFormUniversityAdmNo(candidate.university_adm_number || '');
  setFormDob(candidate.dob ? String(candidate.dob).substring(0, 10) : '');
  setFormAddress(candidate.address || '');
  setFormMobile(candidate.mobile || '');
  setFormWhatsapp(candidate.mobile || '');
  setFormStudyCentre(candidate.college_university || 'ALAGAPPA UNIVERSITY');
  setFormExamCentre(candidate.college_university || 'ALAGAPPA UNIVERSITY');

  // 1. Parse all enrolled courses
  const rawCourses = candidate.target_course || '';
  const parsedCourses = rawCourses
    .split(',')
    .map(c => c.trim())
    .filter(Boolean);

  setStudentEnrolledCourses(parsedCourses);

  // 2. Select the first course
  const primaryCourse = parsedCourses.length > 0 ? parsedCourses[0] : rawCourses;
  setFormCourseName(primaryCourse);

  // 3. ⚡ Resolve the exact master course ID directly from masterCoursesData
  const matchedMaster = getMasterCourseByName(primaryCourse);
  setFormCourseId(matchedMaster?.id || (candidate.course_id ? parseInt(candidate.course_id) : 0));

  // 4. Load syllabus semesters & papers
  const papers = setupSemestersAndPapers(primaryCourse, ['Semester 1']);
  if (papers && papers.length > 0) {
    setSelectedPaperCodes(papers.map(p => p.code));
  }

  setStudentPickerSearch(`${candidate.name} (${candidate.adm_number || candidate.roll_number || `MET-ADM-${candidate.id}`})`);
  setIsPickerDropdownOpen(false);
};

// ⚡ Update course_id whenever switching courses
const handleSwitchCourse = (courseName) => {
  setFormCourseName(courseName);

  // Dynamically assign correct ID (e.g. 15 for MBA, 16 for MCA)
  const matchedMaster = getMasterCourseByName(courseName);
  if (matchedMaster) {
    setFormCourseId(matchedMaster.id);
  }

  const papers = setupSemestersAndPapers(courseName, ['Semester 1']);
  if (papers && papers.length > 0) {
    setSelectedPaperCodes(papers.map(p => p.code));
  }
};
  const fetchApplications = async () => {
    setTableLoading(true);
    try {
      const res = await fetch(
        `https://metapi.emedhatechnologies.com/api/exams/exam-applications?search=${encodeURIComponent(searchTerm)}`
      );
      const result = await res.json();
      if (result.success) setDataList(result.data || []);
      else setDataList([]);
    } catch (err) {
      console.error('Failed to load applications:', err);
      setDataList([]);
    } finally {
      setTableLoading(false);
    }
  };

  const fetchMasterData = async () => {
    try {
      // 1. Fetch Students for dropdown
      const stdRes = await fetch(`https://metapi.emedhatechnologies.com/api/students?tabStatus=all&search=`);
      const stdData = await stdRes.json();
      if (stdData.success) setStudentsList(stdData.data || []);

      // 2. Fetch Master Courses for Syllabus and Papers
      const crsRes = await fetch(`https://metapi.emedhatechnologies.com/api/courses/browse-courses`);
      const crsData = await crsRes.json();
      if (crsData.success) setMasterCoursesData(crsData.data || []);
    } catch (err) {
      console.error('Failed to load master lookup data:', err);
    }
  };

  // Helper: Extract Term Number from Label
  const extractTermNumber = (termStr) => {
    if (!termStr) return '1';
    const match = termStr.match(/\d+/);
    return match ? match[0] : '1';
  };

  // Syllabus and Papers Extraction Engine
const setupSemestersAndPapers = (targetCourseName, targetSems = ['Semester 1'], masterList = masterCoursesData) => {
  if (!targetCourseName) return [];

  // Match exact course name from master table
  const matchedMaster = masterList.find((c) => {
    const dbName = (c.course_name || '').trim().toLowerCase();
    const searchName = targetCourseName.trim().toLowerCase();
    return dbName === searchName;
  });

  const activeCourseCode = matchedMaster?.course_code || '101';
  
  // ⚡ Ensure formCourseId always matches the selected course
  if (matchedMaster?.id) {
    setFormCourseId(matchedMaster.id);
  }

  let parsedSyllabus = [];
  if (matchedMaster && matchedMaster.syllabus_structure) {
    parsedSyllabus = matchedMaster.syllabus_structure;
    if (typeof parsedSyllabus === 'string') {
      try {
        parsedSyllabus = JSON.parse(parsedSyllabus);
        if (typeof parsedSyllabus === 'string') parsedSyllabus = JSON.parse(parsedSyllabus);
      } catch (e) {
        parsedSyllabus = [];
      }
    }
  }

  // Extract semesters
  let sems = [];
  if (Array.isArray(parsedSyllabus) && parsedSyllabus.length > 0) {
    sems = parsedSyllabus.map((s) => s.term).filter((t) => t && t.trim() !== '');
  }
  if (sems.length === 0) {
    const durationYears = parseInt(matchedMaster?.minimum_duration) || 3;
    const isNonSemester = matchedMaster?.structure_type?.toLowerCase().includes('non');
    if (isNonSemester) {
      for (let i = 1; i <= durationYears; i++) sems.push(`Year ${i}`);
    } else {
      for (let i = 1; i <= durationYears * 2; i++) sems.push(`Semester ${i}`);
    }
  }
  setAvailableSemesters(sems);

  const activeSems = targetSems.length > 0 ? targetSems : [sems[0] || 'Semester 1'];
  setSelectedSemesters(activeSems);

  // Extract subject papers
  let aggregatedPapers = [];
  activeSems.forEach((semName) => {
    const semNum = extractTermNumber(semName);
    const matchedSemObj = parsedSyllabus.find(
      (s) => (s.term || '').trim().toLowerCase() === semName.trim().toLowerCase()
    );

    if (matchedSemObj && Array.isArray(matchedSemObj.papers)) {
      const papers = matchedSemObj.papers
        .filter((p) => p && p.trim() !== '')
        .map((p, idx) => ({
          code: `${activeCourseCode}${semNum}${idx + 1}`,
          title: p.trim(),
          semester: semName,
        }));
      aggregatedPapers = [...aggregatedPapers, ...papers];
    }
  });

  setAllAvailablePapers(aggregatedPapers);
  return aggregatedPapers;
};

  // Student Select Handler in Form
  const handleStudentSelect = (studentId) => {
    setFormStudentId(studentId);
    const matched = studentsList.find((s) => String(s.id) === String(studentId));
    if (matched) {
      setFormStudentName(matched.name || '');
      setFormFatherName(matched.father_name || '');
      setFormGender(matched.gender || 'Male');
      setFormEnrolmentNo(matched.roll_number || matched.adm_number || `MET-ADM-${matched.id}`);
      setFormUniversityAdmNo(matched.university_adm_number || '');
      setFormDob(matched.dob ? String(matched.dob).substring(0, 10) : '');
      setFormAddress(matched.address || '');
      setFormMobile(matched.mobile || '');
      setFormWhatsapp(matched.mobile || '');
      setFormStudyCentre(matched.college_university || 'ALAGAPPA UNIVERSITY');
      setFormExamCentre(matched.college_university || 'ALAGAPPA UNIVERSITY');

      const primaryCourse = (matched.target_course || '').split(',')[0].trim();
      setFormCourseName(primaryCourse);
      setFormCourseId(matched.course_id ? parseInt(matched.course_id) : 0);

      const papers = setupSemestersAndPapers(primaryCourse, ['Semester 1']);
      if (papers && papers.length > 0) {
        setSelectedPaperCodes(papers.map((p) => p.code));
      }
    }
  };

  // Toggle Semester Checkbox
  const toggleSemester = (sem) => {
    let updated;
    if (selectedSemesters.includes(sem)) {
      if (selectedSemesters.length === 1) return; // Keep at least one
      updated = selectedSemesters.filter((s) => s !== sem);
    } else {
      updated = [...selectedSemesters, sem];
    }
    const papers = setupSemestersAndPapers(formCourseName, updated);
    if (papers) {
      setSelectedPaperCodes(papers.map((p) => p.code));
    }
  };

  // Toggle Paper Checkbox
  const togglePaper = (code) => {
    if (selectedPaperCodes.includes(code)) {
      setSelectedPaperCodes(selectedPaperCodes.filter((c) => c !== code));
    } else {
      setSelectedPaperCodes([...selectedPaperCodes, code]);
    }
  };

  // Open "Add Application" Modal
  const handleOpenAddModal = () => {
    setEditingId(null);
    setFormStudentId('');
    setFormStudentName('');
    setFormFatherName('');
    setFormGender('Male');
    setFormEnrolmentNo('');
    setFormUniversityAdmNo('');
    setFormDob('');
    setFormAddress('');
    setFormMobile('');
    setFormWhatsapp('');
    setFormCourseName('');
    setFormCourseId(0);
    setFormStudyCentre('ALAGAPPA UNIVERSITY');
    setFormExamCentre('ALAGAPPA UNIVERSITY');
    setExamMonthYear('Dec 2026');
    setFormStatus('Submitted');
    setSelectedSemesters(['Semester 1']);
    setAllAvailablePapers([]);
    setSelectedPaperCodes([]);
    setIsFormModalOpen(true);
  };

  // Open "Edit Application" Modal
  const handleOpenEditModal = (app) => {
    setEditingId(app.id);
    setFormStudentId(app.student_id || '');
    setFormStudentName(app.student_name || '');
    setFormFatherName(app.father_name || '');
    setFormGender(app.gender || 'Male');
    setFormEnrolmentNo(app.enrolment_number || '');
    setFormUniversityAdmNo(app.enrolment_number || '');
    setFormDob(app.dob || '');
    setFormAddress(app.permanent_address || '');
    setFormMobile(app.mobile_number || '');
    setFormWhatsapp(app.whatsapp_number || app.mobile_number || '');
    setFormCourseName(app.course_name || '');
    setFormCourseId(app.course_id || 0);
    setFormStudyCentre(app.study_centre_name || 'ALAGAPPA UNIVERSITY');
    setFormExamCentre(app.examination_centre || app.study_centre_name || 'ALAGAPPA UNIVERSITY');
    setExamMonthYear(app.exam_month_year || 'Dec 2026');
    setFormStatus(app.status || 'Submitted');

    const sems = app.appearing_semester 
      ? app.appearing_semester.split(',').map((s) => s.trim()).filter(Boolean)
      : ['Semester 1'];
    
    setupSemestersAndPapers(app.course_name, sems);

    let parsedSubjects = [];
    if (app.subjects_json) {
      try {
        parsedSubjects = typeof app.subjects_json === 'string' ? JSON.parse(app.subjects_json) : app.subjects_json;
      } catch (e) {
        parsedSubjects = [];
      }
    }
    setSelectedPaperCodes(parsedSubjects.map((p) => p.code));
    setIsFormModalOpen(true);
  };

  // Submit Handler for Add / Edit
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!formStudentName || !formMobile || !formCourseName) {
      alert('Please fill in candidate name, contact mobile, and course stream.');
      return;
    }

    const finalSubjects = allAvailablePapers.filter((p) => selectedPaperCodes.includes(p.code));
    if (finalSubjects.length === 0) {
      alert('Please check at least one examination paper.');
      return;
    }

    setSubmitting(true);
    try {
      const payload = {
        studentId: formStudentId || 0,
        courseId: formCourseId || 0,
        courseName: formCourseName,
        studyCentreName: formStudyCentre,
        examinationCentre: formExamCentre,
        examMonthYear: formExamMonthYear,
        studentName: formStudentName,
        fatherName: formFatherName,
        gender: formGender,
        enrolmentNumber: formEnrolmentNo,
        universityAdmNumber: formUniversityAdmNo,
        dob: formDob,
        permanentAddress: formAddress,
        mobileNumber: formMobile,
        whatsappNumber: formWhatsapp,
        appearingYear: '',
        appearingSemester: selectedSemesters.join(', '),
        subjects: finalSubjects,
        noOfPapers: finalSubjects.length,
        status: formStatus
      };

      const url = editingId
        ? `https://metapi.emedhatechnologies.com/api/courses/exam-application/update/${editingId}`
        : `https://metapi.emedhatechnologies.com/api/courses/exam-application/submit`;

      const method = editingId ? 'PUT' : 'POST';

      const res = await fetch(url, {
        method: method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const result = await res.json();

      if (result.success) {
        setIsFormModalOpen(false);
        fetchApplications();
        alert(editingId ? 'Application updated successfully!' : 'Application created successfully!');
      } else {
        alert(result.message || 'Operation failed.');
      }
    } catch (err) {
      console.error('Error saving exam application:', err);
      alert('Network error while saving application.');
    } finally {
      setSubmitting(false);
    }
  };

  // Delete Handler
  const handleDeleteApplication = async (id) => {
    if (!window.confirm(`Are you sure you want to delete application record #${id}?`)) return;

    try {
      const res = await fetch(`https://metapi.emedhatechnologies.com/api/courses/exam-application/delete/${id}`, {
        method: 'DELETE'
      });
      const result = await res.json();
      if (result.success) {
        fetchApplications();
      } else {
        alert(result.message || 'Failed to delete record.');
      }
    } catch (err) {
      console.error('Delete error:', err);
      alert('Network error deleting record.');
    }
  };

  // Excel Export
  const handleExportToExcel = () => {
    if (dataList.length === 0) {
      alert("No examination application records available to export.");
      return;
    }

    const exportData = dataList.map((item, index) => ({
      "S.No": index + 1,
      "Application ID": `#${item.id}`,
      "Enrolment Number": item.enrolment_number || 'N/A',
      "Applicant Name": item.student_name || 'N/A',
      "Mobile Number": item.mobile_number || 'N/A',
      "Father Name": item.father_name || 'N/A',
      "Gender": item.gender || 'N/A',
      "DOB": item.dob || 'N/A',
      "Course Track": item.course_name || 'N/A',
      "Appearing Term/Semester": item.appearing_semester || 'Semester 1',
      "Exam Session": item.exam_month_year || 'N/A',
      "No of Papers": item.no_of_papers_appeared || (item.subjects_list ? item.subjects_list.length : 0),
      "Fee Paid (INR)": parseFloat(item.amount_paid || 0),
      "Application Status": item.status || 'Submitted',
      "Study / Exam Centre": item.study_centre_name || 'ALAGAPPA UNIVERSITY',
      "Applied Date": item.created_at ? new Date(item.created_at).toLocaleDateString('en-IN') : 'N/A'
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Exam_Applications");

    const fileName = `Exam_Applications_Report_${new Date().toISOString().substring(0, 10)}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };


  // 1. 📄 Export Individual Student Examination Application Form as PDF
const handleDownloadSingleApplicationPDF = (app) => {
  if (!app) return;
  const doc = new jsPDF({ unit: 'pt', format: 'a4' });

  // Top Header Banner
  doc.setFillColor(15, 23, 42); // Dark Slate #0f172a
  doc.rect(0, 0, doc.internal.pageSize.width, 60, 'F');

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(15);
  doc.setTextColor(255, 255, 255);
  doc.text("APPLICATION FOR UNIVERSITY EXAMINATION", 40, 28);

  doc.setFontSize(9.5);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(148, 163, 184);
  doc.text(app.study_centre_name || "ALAGAPPA UNIVERSITY STUDY CENTRE", 40, 46);

  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(56, 189, 248);
  doc.text(`App ID: #${app.id}`, doc.internal.pageSize.width - 40, 36, { align: 'right' });

  // Candidate Details Table
  autoTable(doc, {
    startY: 75,
    theme: 'plain',
    body: [
      ['Applicant Name:', (app.student_name || 'N/A').toUpperCase(), 'Enrolment No:', app.enrolment_number || 'N/A'],
      ['Father Name:', app.father_name || 'N/A', 'Course Track:', app.course_name || 'N/A'],
      ['Gender / DOB:', `${app.gender || 'N/A'} / ${app.dob || 'N/A'}`, 'Appearing Term:', app.appearing_semester || 'Semester 1'],
      ['Mobile Number:', app.mobile_number || 'N/A', 'Exam Session:', app.exam_month_year || 'Dec 2026'],
      ['Exam Centre:', app.examination_centre || app.study_centre_name || 'ALAGAPPA UNIVERSITY', 'Application Status:', app.status || 'Submitted'],
      ['Address:', { content: app.permanent_address || 'N/A', colSpan: 3 }]
    ],
    styles: { fontSize: 8.5, textColor: [51, 65, 85], cellPadding: 3.5 },
    columnStyles: {
      0: { fontStyle: 'bold', cellWidth: 95 },
      2: { fontStyle: 'bold', cellWidth: 95 }
    }
  });

  // Parse Subjects List
  let subjects = [];
  if (app.subjects_json) {
    try {
      subjects = typeof app.subjects_json === 'string' ? JSON.parse(app.subjects_json) : app.subjects_json;
    } catch (e) {
      subjects = [];
    }
  }

  const subjectRows = subjects.map((sub, idx) => [
    String(idx + 1).padStart(2, '0'),
    sub.code || 'N/A',
    sub.title || 'N/A',
    sub.semester || app.appearing_semester || 'Active Term'
  ]);

  // Subjects Table
  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 12,
    theme: 'grid',
    head: [['#', 'Subject Code', 'Title of the Course Paper', 'Term']],
    body: subjectRows.length > 0 ? subjectRows : [['-', '-', 'No subject papers attached', '-']],
    headStyles: { fillColor: [28, 110, 201], textColor: [255, 255, 255], fontStyle: 'bold', fontSize: 8.5 },
    bodyStyles: { fontSize: 8.5, textColor: [51, 65, 85] },
    alternateRowStyles: { fillColor: [248, 250, 252] },
    columnStyles: {
      0: { halign: 'center', cellWidth: 28 },
      1: { fontStyle: 'bold', textColor: [37, 99, 235], cellWidth: 80 },
      3: { cellWidth: 90 }
    }
  });

  // Footer Signatures
  const finalY = doc.lastAutoTable.finalY + 45;
  if (finalY < doc.internal.pageSize.height - 40) {
    doc.setFontSize(8.5);
    doc.setTextColor(100, 116, 139);
    doc.text("Candidate Signature", 50, finalY);
    doc.text("Authorized Center Coordinator", doc.internal.pageSize.width - 50, finalY, { align: 'right' });
    doc.setDrawColor(203, 213, 225);
    doc.line(50, finalY - 12, 160, finalY - 12);
    doc.line(doc.internal.pageSize.width - 180, finalY - 12, doc.internal.pageSize.width - 50, finalY - 12);
  }

  doc.save(`Exam_App_${app.enrolment_number || app.id}_${(app.student_name || 'Candidate').replace(/\s+/g, '_')}.pdf`);
};

// 2. 📊 Export Filtered Applications Table to PDF
const handleExportAllToPDF = () => {
  if (dataList.length === 0) {
    alert("No examination application records available to export.");
    return;
  }

  const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });

  // Banner
  doc.setFillColor(15, 23, 42);
  doc.rect(0, 0, doc.internal.pageSize.width, 55, 'F');
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(15);
  doc.setTextColor(255, 255, 255);
  doc.text("EXAMINATION APPLICATIONS MASTER REPORT", 40, 28);

  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(148, 163, 184);
  doc.text(`Total Records: ${dataList.length} | Generated on: ${new Date().toLocaleDateString('en-IN')}`, 40, 44);

  const tableColumns = [
    { header: '#', dataKey: 'index' },
    { header: 'Enrolment No', dataKey: 'enrolment_number' },
    { header: 'Student Name', dataKey: 'student_name' },
    { header: 'Mobile', dataKey: 'mobile_number' },
    { header: 'Course Track', dataKey: 'course_name' },
    { header: 'Appearing Term', dataKey: 'appearing_semester' },
    { header: 'Exam Session', dataKey: 'exam_month_year' },
    { header: 'Papers', dataKey: 'papers' },
    { header: 'Status', dataKey: 'status' }
  ];

  const tableRows = dataList.map((item, i) => ({
    index: String(i + 1).padStart(2, '0'),
    enrolment_number: item.enrolment_number || 'N/A',
    student_name: (item.student_name || 'N/A').toUpperCase(),
    mobile_number: item.mobile_number || 'N/A',
    course_name: item.course_name || 'N/A',
    appearing_semester: item.appearing_semester || 'Semester 1',
    exam_month_year: item.exam_month_year || 'Dec 2026',
    papers: `${item.no_of_papers_appeared || 0} Papers`,
    status: item.status || 'Submitted'
  }));

  autoTable(doc, {
    startY: 68,
    columns: tableColumns,
    body: tableRows,
    theme: 'grid',
    headStyles: { fillColor: [28, 110, 201], textColor: [255, 255, 255], fontStyle: 'bold', fontSize: 8.5 },
    bodyStyles: { fontSize: 8, textColor: [51, 65, 85] },
    alternateRowStyles: { fillColor: [248, 250, 252] },
    columnStyles: {
      index: { halign: 'center', cellWidth: 26 },
      enrolment_number: { fontStyle: 'bold', textColor: [30, 64, 175] }
    },
    margin: { left: 40, right: 40, bottom: 40 }
  });

  doc.save(`Exam_Applications_Report_${new Date().toISOString().substring(0, 10)}.pdf`);
};

// 🖨️ Direct Print Engine with Clean Document UI/UX
const handleDirectPrintApplication = (app) => {
  if (!app) return;

  let parsedSubjects = [];
  if (app.subjects_json) {
    try {
      parsedSubjects = typeof app.subjects_json === 'string' ? JSON.parse(app.subjects_json) : app.subjects_json;
    } catch (e) {
      parsedSubjects = [];
    }
  }

  const printWindow = window.open('', '_blank', 'width=900,height=700');
  if (!printWindow) {
    alert("Please allow popups to open the print dialog.");
    return;
  }

  const printHTML = `
    <!DOCTYPE html>
    <html>
      <head>
        <title>Exam Application - ${app.enrolment_number || app.student_name}</title>
        <style>
          @page { size: A4 portrait; margin: 15mm; }
          * { box-sizing: border-box; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif; color: #0f172a; margin: 0; padding: 10px; font-size: 13px; line-height: 1.4; }
          
          /* Header */
          .header-banner { border-bottom: 2px solid #1e40af; padding-bottom: 14px; margin-bottom: 16px; display: flex; justify-content: space-between; align-items: flex-start; }
          .inst-title { font-size: 18px; font-weight: 800; color: #1e40af; text-transform: uppercase; margin: 0 0 4px 0; }
          .inst-sub { font-size: 12px; color: #475569; font-weight: 600; margin: 0; }
          .doc-badge { background: #eff6ff; border: 1px solid #bfdbfe; color: #1e40af; font-weight: 800; font-size: 11px; padding: 4px 10px; border-radius: 4px; text-transform: uppercase; }
          
          /* Metadata Matrix */
          .section-title { font-size: 11px; font-weight: 800; color: #475569; text-transform: uppercase; letter-spacing: 0.5px; margin: 14px 0 6px 0; }
          .info-table { width: 100%; border-collapse: collapse; margin-bottom: 14px; border: 1px solid #e2e8f0; }
          .info-table td { padding: 7px 10px; font-size: 12.5px; border: 1px solid #e2e8f0; }
          .info-table td.label { font-weight: 700; color: #475569; background: #f8fafc; width: 18%; }
          .info-table td.val { font-weight: 600; color: #0f172a; width: 32%; }
          
          /* Subjects Table */
          .subjects-table { width: 100%; border-collapse: collapse; margin-top: 6px; }
          .subjects-table th { background: #f1f5f9; color: #334155; font-size: 11px; font-weight: 700; text-transform: uppercase; padding: 8px 10px; border: 1px solid #cbd5e1; text-align: left; }
          .subjects-table td { padding: 8px 10px; border: 1px solid #e2e8f0; font-size: 12px; }
          .sub-code { font-weight: 800; color: #2563eb; }

          /* Declaration & Signatures */
          .declaration-box { margin-top: 20px; font-size: 11px; color: #64748b; text-align: justify; line-height: 1.5; border-top: 1px dashed #cbd5e1; padding-top: 10px; }
          .signatures-dock { display: flex; justify-content: space-between; margin-top: 50px; padding: 0 15px; }
          .sig-line-box { width: 180px; text-align: center; font-size: 11.5px; font-weight: 700; color: #334155; }
          .sig-line { border-top: 1px solid #94a3b8; margin-bottom: 6px; }
        </style>
      </head>
      <body>
        <div class="header-banner">
          <div>
            <h1 class="inst-title">${app.study_centre_name || 'ALAGAPPA UNIVERSITY'}</h1>
            <p class="inst-sub">Centre for Distance and Online Education • Examination Wing</p>
          </div>
          <div style="text-align: right;">
            <div class="doc-badge">Exam Application</div>
            <div style="font-size: 11px; color: #64748b; margin-top: 4px;">App ID: #${app.id}</div>
          </div>
        </div>

        <div class="section-title">Candidate & Registration Details</div>
        <table class="info-table">
          <tr>
            <td class="label">Candidate Name</td>
            <td class="val"><strong>${(app.student_name || '').toUpperCase()}</strong></td>
            <td class="label">Enrolment / Reg No</td>
            <td class="val" style="color: #1e40af; font-weight: 800;">${app.enrolment_number || 'N/A'}</td>
          </tr>
          <tr>
            <td class="label">Father's Name</td>
            <td class="val">${app.father_name || '-'}</td>
            <td class="label">Gender / DOB</td>
            <td class="val">${app.gender || '-'} / ${app.dob || '-'}</td>
          </tr>
          <tr>
            <td class="label">Course Track</td>
            <td class="val"><strong>${app.course_name || '-'}</strong></td>
            <td class="label">Exam Session</td>
            <td class="val">${app.exam_month_year || 'Dec 2026'}</td>
          </tr>
          <tr>
            <td class="label">Appearing Term</td>
            <td class="val">${app.appearing_semester || 'Semester 1'}</td>
            <td class="label">Contact Mobile</td>
            <td class="val">${app.mobile_number || '-'}</td>
          </tr>
          <tr>
            <td class="label">Exam Centre</td>
            <td class="val" colspan="3">${app.examination_centre || app.study_centre_name || 'ALAGAPPA UNIVERSITY'}</td>
          </tr>
          ${app.permanent_address ? `
          <tr>
            <td class="label">Permanent Address</td>
            <td class="val" colspan="3">${app.permanent_address}</td>
          </tr>` : ''}
        </table>

        <div class="section-title">Subjects Appearing (${parsedSubjects.length} Papers)</div>
        <table class="subjects-table">
          <thead>
            <tr>
              <th style="width: 35px; text-align: center;">#</th>
              <th style="width: 100px;">Subject Code</th>
              <th>Title of the Course Paper</th>
              <th style="width: 110px;">Term / Sem</th>
            </tr>
          </thead>
          <tbody>
            ${parsedSubjects.length === 0 ? `
              <tr><td colspan="4" style="text-align: center; color: #94a3b8; padding: 12px;">No specific subjects assigned.</td></tr>
            ` : parsedSubjects.map((sub, idx) => `
              <tr>
                <td style="text-align: center; color: #64748b;">${idx + 1}</td>
                <td class="sub-code">${sub.code || '-'}</td>
                <td><strong>${sub.title || '-'}</strong></td>
                <td>${sub.semester || app.appearing_semester || '-'}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>

        <div class="declaration-box">
          <strong>Declaration:</strong> I hereby declare that all the particulars stated in this examination application are true, complete, and correct to the best of my knowledge and belief.
        </div>

        <div class="signatures-dock">
          <div class="sig-line-box">
            <div class="sig-line"></div>
            Candidate Signature
          </div>
          <div class="sig-line-box">
            <div class="sig-line"></div>
            Center Coordinator / Seal
          </div>
        </div>
      </body>
    </html>
  `;

  printWindow.document.open();
  printWindow.document.write(printHTML);
  printWindow.document.close();

  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
};

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return isNaN(d.getTime()) ? dateStr : d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = dataList.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(dataList.length / itemsPerPage);

  return (
    <div style={styles.container}>
      
      {/* ⚡ HEADER & SEARCH ACTION DOCK */}
  {/* ⚡ HEADER & SEARCH ACTION DOCK */}
<div style={styles.filterControlPanel}>
  <div style={styles.searchWrapper}>
    <Search size={16} style={styles.searchIcon} />
    <input
      type="text"
      placeholder="Search candidate name, enrollment no, course, mobile..."
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
      }}
      style={styles.tableSearchInput}
    />
  </div>

  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
    {/* Add Application Button */}
    <button onClick={handleOpenAddModal} style={styles.addAppBtn}>
      <Plus size={15} /> Add Application
    </button>

    {/* Export to Excel Button */}
    <button onClick={handleExportToExcel} style={styles.exportExcelBtn} title="Export to Excel">
      <Download size={14} /> Export Excel
    </button>

    {/* ➕ Top-Level Export to PDF Button */}
    <button onClick={handleExportAllToPDF} style={styles.pdfExportBtn} title="Download Table PDF Statement">
      <Download size={14} /> Download PDF
    </button>

    <div style={styles.totalIndicator}>
      Total: <strong style={{ color: '#1c6ec9' }}>{dataList.length}</strong>
    </div>
  </div>
</div>

      {/* ⚡ MASTER DATA TABLE */}
      {tableLoading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '60px' }}>
          <Loader2 size={32} style={{ animation: 'spin 1s linear infinite' }} color="#1c6ec9" />
        </div>
      ) : (
        <div style={{ overflowX: 'auto', width: '100%', borderRadius: '14px', border: '1px solid #e2e8f0', background: '#fff' }}>
          <table style={styles.dataTable}>
            <thead>
              <tr>
                <th style={styles.tableTh}>Enrolment No</th>
                <th style={styles.tableTh}>Applicant Name</th>
                <th style={styles.tableTh}>Course Track</th>
                <th style={styles.tableTh}>Term / Sem</th>
                <th style={styles.tableTh}>Exam Session</th>
                <th style={styles.tableTh}>Papers</th>
                <th style={styles.tableTh}>Status</th>
                <th style={styles.tableTh}>Applied Date</th>
                <th style={{ ...styles.tableTh, textAlign: 'center' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {dataList.length === 0 ? (
                <tr>
                  <td colSpan="9" style={styles.noDataTd}>
                    No examination applications found matching your criteria.
                  </td>
                </tr>
              ) : (
                currentItems.map((item) => (
                  <tr key={item.id} style={styles.tableTr}>
                    <td style={{ ...styles.tableTd, fontWeight: '700', color: '#1e40af' }}>
                      {item.enrolment_number}
                    </td>
                    <td style={{ ...styles.tableTd, fontWeight: '700', color: '#0f172a' }}>
                      {item.student_name}
                      <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '500' }}>
                        {item.mobile_number}
                      </div>
                    </td>
                    <td style={{ ...styles.tableTd, color: '#334155', fontWeight: '600' }}>
                      {item.course_name}
                    </td>
                    <td style={styles.tableTd}>
                      <span style={styles.termLabel}>{item.appearing_semester || 'Semester 1'}</span>
                    </td>
                    <td style={{ ...styles.tableTd, color: '#475569', fontSize: '12.5px' }}>
                      {item.exam_month_year}
                    </td>
                    <td style={{ ...styles.tableTd, textAlign: 'center', fontWeight: '700', color: '#2563eb' }}>
                      {item.no_of_papers_appeared || (item.subjects_list ? item.subjects_list.length : 0)} Papers
                    </td>
                    <td style={styles.tableTd}>
                      <span
                        style={{
                          ...styles.statusPill,
                          ...(item.status === 'Approved'
                            ? styles.statusApproved
                            : item.status === 'Rejected'
                            ? styles.statusRejected
                            : styles.statusSubmitted),
                        }}
                      >
                        {item.status || 'Submitted'}
                      </span>
                    </td>
                    <td style={{ ...styles.tableTd, fontSize: '12px', color: '#64748b' }}>
                      {formatDate(item.created_at)}
                    </td>
                    <td style={styles.tableTd}>
                      <div style={{ display: 'flex', gap: '6px', justifyContent: 'center' }}>
                      <button
      onClick={() => handleDownloadSingleApplicationPDF(item)}
      style={styles.actionIconButton}
      title="Download Individual Application Form (PDF)"
    >
     <Download size={14} />
    </button>
                        <button
                          onClick={() => setSelectedApp(item)}
                          style={styles.actionIconButton}
                          title="View Full Application"
                        >
                          <Eye size={13} color="#2563eb" />
                        </button>
                        <button
                          onClick={() => handleOpenEditModal(item)}
                          style={styles.actionIconButton}
                          title="Edit Application"
                        >
                          <Edit3 size={13} color="#059669" />
                        </button>
                        <button
                          onClick={() => handleDeleteApplication(item.id)}
                          style={styles.actionIconButton}
                          title="Delete Record"
                        >
                          <Trash2 size={13} color="#dc2626" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* ⚡ PAGINATION */}
      {dataList.length > 0 && (
        <div style={styles.paginationDock}>
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            style={currentPage === 1 ? { ...styles.pageBtn, ...styles.pageBtnDisabled } : styles.pageBtn}
          >
            Previous
          </button>
          <span style={styles.pageIndicator}>
            Page <strong>{currentPage}</strong> of {totalPages || 1}
          </span>
          <button
            disabled={currentPage === totalPages || totalPages === 0}
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            style={currentPage === totalPages || totalPages === 0 ? { ...styles.pageBtn, ...styles.pageBtnDisabled } : styles.pageBtn}
          >
            Next
          </button>
        </div>
      )}

      {/* ⚡ MODAL 1: ADD / EDIT EXAMINATION APPLICATION FORM */}
{isFormModalOpen && (
  <div style={styles.modalBackdrop}>
    <div style={{ ...styles.modalWrapperCard, maxWidth: '820px' }}>
      <div style={styles.modalHeader}>
        <div>
          <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '800', color: '#0f172a' }}>
            {editingId ? `Edit Examination Application #${editingId}` : 'Submit Examination Application'}
          </h3>
          <span style={{ fontSize: '12px', color: '#64748b' }}>
            Search candidate, auto-fill credentials, select enrolled course & configure papers
          </span>
        </div>
        <button onClick={() => setIsFormModalOpen(false)} style={styles.modalCloseX}>
          <X size={18} />
        </button>
      </div>

      <form onSubmit={handleFormSubmit} style={styles.modalFormBody}>
        
        {/* 1. SEARCHABLE STUDENT PICKER */}
        {!editingId && (
          <div style={styles.studentSearchPickerBox}>
            <label style={styles.fieldLabel}>Search & Select Enrolled Student *</label>
            <div style={{ position: 'relative' }}>
              <div style={styles.inputWithIconBox}>
                <Search size={15} style={styles.inlineSearchIcon} />
                <input
                  type="text"
                  required
                  placeholder="Type student name, mobile, admission no, or course..."
                  value={studentPickerSearch}
                  onChange={(e) => {
                    setStudentPickerSearch(e.target.value);
                    setIsPickerDropdownOpen(true);
                  }}
                  onFocus={() => setIsPickerDropdownOpen(true)}
                  style={styles.fieldInputWithIcon}
                />
                {studentPickerSearch && (
                  <button 
                    type="button" 
                    onClick={() => {
                      setStudentPickerSearch('');
                      setFormStudentId('');
                      setStudentEnrolledCourses([]);
                      setFormCourseName('');
                      setIsPickerDropdownOpen(false);
                    }}
                    style={styles.pickerClearBtn}
                  >
                    ✕
                  </button>
                )}
              </div>

              {/* Dropdown search results */}
              {isPickerDropdownOpen && (
                <div style={styles.studentSearchResultsDropdown}>
                  {filteredCandidateList.length === 0 ? (
                    <div style={{ padding: '12px', fontSize: '12px', color: '#94a3b8', textAlign: 'center' }}>
                      No matching students found.
                    </div>
                  ) : (
                    filteredCandidateList.slice(0, 15).map((candidate) => (
                      <div
                        key={candidate.id}
                        onClick={() => handleSelectCandidate(candidate)}
                        style={styles.candidateResultItem}
                      >
                        <div>
                          <strong style={{ color: '#0f172a', fontSize: '13px' }}>{candidate.name}</strong>
                          <span style={{ color: '#64748b', fontSize: '11.5px', marginLeft: '6px' }}>
                            ({candidate.adm_number || candidate.roll_number || `MET-ADM-${candidate.id}`})
                          </span>
                          <div style={{ fontSize: '11px', color: '#1e40af', marginTop: '2px' }}>
                            🎓 {candidate.target_course} • 📱 {candidate.mobile}
                          </div>
                        </div>
                        {candidate.university_adm_number ? (
                          <span style={styles.univPill}>
                            Univ: {candidate.university_adm_number}
                          </span>
                        ) : null}
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          </div>
        )}

        {/* 2. DYNAMIC ENROLLED COURSE SELECTOR (Single vs. Multiple Handling) */}
        <div style={styles.fieldContainer}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
            <label style={styles.fieldLabel}>
              Enrolled Course Track * 
              {studentEnrolledCourses.length > 1 && (
                <span style={{ color: '#1e40af', fontWeight: '800', marginLeft: '6px' }}>
                  ({studentEnrolledCourses.length} Courses Enrolled — Select Active)
                </span>
              )}
            </label>
          </div>

          {studentEnrolledCourses.length > 1 ? (
            /* Multi-Course Enrolled: Interactive Choice Chips */
            <div style={styles.coursePillsContainer}>
              {studentEnrolledCourses.map((cName, idx) => {
                const isActive = formCourseName.trim().toLowerCase() === cName.trim().toLowerCase();
                return (
                  <button
                    key={idx}
                    type="button"
                    onClick={() => handleSwitchCourse(cName)}
                    style={{
                      ...styles.courseToggleChip,
                      background: isActive ? '#1e40af' : '#f8fafc',
                      color: isActive ? '#ffffff' : '#334155',
                      borderColor: isActive ? '#1e40af' : '#cbd5e1'
                    }}
                  >
                    {isActive ? '✓ ' : ''} {cName}
                  </button>
                );
              })}
            </div>
          ) : (
            /* Single Course Enrolled: Direct Input Display */
            <input
              type="text"
              required
              placeholder="e.g. B.Com or MBA"
              value={formCourseName}
              onChange={(e) => {
                setFormCourseName(e.target.value);
                setupSemestersAndPapers(e.target.value, selectedSemesters);
              }}
              style={styles.formInput}
            />
          )}
        </div>

        {/* 3. REGISTRATION & UNIVERSITY ADMISSION NUMBERS */}
        <div style={styles.formSplitGrid}>
          <div style={styles.fieldContainer}>
            <label style={styles.fieldLabel}>Institute Enrolment / Reg No. *</label>
            <input
              type="text"
              required
              placeholder="e.g. MET-ADM-14"
              value={formEnrolmentNo}
              onChange={(e) => setFormEnrolmentNo(e.target.value)}
              style={styles.formInput}
            />
          </div>
          <div style={styles.fieldContainer}>
            <label style={styles.fieldLabel}>University Admission / Reg No. *</label>
            <input
              type="text"
              required
              placeholder="e.g. AU-2026-REG-5698"
              value={formUniversityAdmNo}
              onChange={(e) => setFormUniversityAdmNo(e.target.value)}
              style={styles.formInput}
            />
          </div>
        </div>

        {/* 4. EXAM SESSION & CENTRES */}
        <div style={styles.formSplitGrid3}>
          <div style={styles.fieldContainer}>
            <label style={styles.fieldLabel}>Exam Month & Year *</label>
            <input
              type="text"
              required
              placeholder="e.g. Dec 2026"
              value={formExamMonthYear}
              onChange={(e) => setExamMonthYear(e.target.value)}
              style={styles.formInput}
            />
          </div>
          <div style={styles.fieldContainer}>
            <label style={styles.fieldLabel}>Study Centre</label>
            <input
              type="text"
              value={formStudyCentre}
              onChange={(e) => setFormStudyCentre(e.target.value)}
              style={styles.formInput}
            />
          </div>
          <div style={styles.fieldContainer}>
            <label style={styles.fieldLabel}>Exam Centre *</label>
            <input
              type="text"
              required
              placeholder="Venue"
              value={formExamCentre}
              onChange={(e) => setFormExamCentre(e.target.value)}
              style={styles.formInput}
            />
          </div>
        </div>

        {/* 5. CANDIDATE PERSONAL DETAILS */}
        <div style={styles.formSplitGrid}>
          <div style={styles.fieldContainer}>
            <label style={styles.fieldLabel}>Applicant Full Name *</label>
            <input
              type="text"
              required
              value={formStudentName}
              onChange={(e) => setFormStudentName(e.target.value)}
              style={styles.formInput}
            />
          </div>
          <div style={styles.fieldContainer}>
            <label style={styles.fieldLabel}>Father's Name</label>
            <input
              type="text"
              value={formFatherName}
              onChange={(e) => setFormFatherName(e.target.value)}
              style={styles.formInput}
            />
          </div>
        </div>

        {/* 6. GENDER, DOB & CONTACTS */}
        <div style={styles.formSplitGrid3}>
          <div style={styles.fieldContainer}>
            <label style={styles.fieldLabel}>Gender</label>
            <select
              value={formGender}
              onChange={(e) => setFormGender(e.target.value)}
              style={styles.formSelect}
            >
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Transgender">Transgender</option>
            </select>
          </div>
          <div style={styles.fieldContainer}>
            <label style={styles.fieldLabel}>Date of Birth</label>
            <input
              type="date"
              value={formDob}
              onChange={(e) => setFormDob(e.target.value)}
              style={styles.formInput}
            />
          </div>
          <div style={styles.fieldContainer}>
            <label style={styles.fieldLabel}>Mobile Number *</label>
            <input
              type="text"
              required
              value={formMobile}
              onChange={(e) => setFormMobile(e.target.value)}
              style={styles.formInput}
            />
          </div>
        </div>

        {/* 7. PERMANENT ADDRESS */}
        <div style={styles.fieldContainer}>
          <label style={styles.fieldLabel}>Permanent Residential Address</label>
          <input
            type="text"
            placeholder="Address with Pincode"
            value={formAddress}
            onChange={(e) => setFormAddress(e.target.value)}
            style={styles.formInput}
          />
        </div>

        {/* 8. MULTI-SEMESTER SELECTION CHIPS */}
        <div style={styles.fieldContainer}>
          <label style={styles.fieldLabel}>Appearing Terms / Semesters for {formCourseName || 'Selected Course'}</label>
          <div style={styles.checkboxPillsContainer}>
            {availableSemesters.length === 0 ? (
              <span style={{ fontSize: '12px', color: '#94a3b8', fontStyle: 'italic' }}>
                Select a course to view available semester terms.
              </span>
            ) : (
              availableSemesters.map((sem, idx) => {
                const isSelected = selectedSemesters.includes(sem);
                return (
                  <button
                    key={idx}
                    type="button"
                    onClick={() => toggleSemester(sem)}
                    style={{
                      ...styles.semesterToggleChip,
                      background: isSelected ? '#1e40af' : '#f8fafc',
                      color: isSelected ? '#ffffff' : '#334155',
                      borderColor: isSelected ? '#1e40af' : '#cbd5e1'
                    }}
                  >
                    {isSelected ? '✓ ' : '+ '} {sem}
                  </button>
                );
              })
            )}
          </div>
        </div>

        {/* 9. SUBJECT PAPERS CHECKLIST */}
        <div style={styles.fieldContainer}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
            <label style={styles.fieldLabel}>
              Subjects Appearing ({selectedPaperCodes.length} of {allAvailablePapers.length} Selected)
            </label>
            {allAvailablePapers.length > 0 && (
              <button
                type="button"
                onClick={() => {
                  if (selectedPaperCodes.length === allAvailablePapers.length) {
                    setSelectedPaperCodes([]);
                  } else {
                    setSelectedPaperCodes(allAvailablePapers.map((p) => p.code));
                  }
                }}
                style={styles.linkButton}
              >
                {selectedPaperCodes.length === allAvailablePapers.length ? 'Deselect All' : 'Select All Papers'}
              </button>
            )}
          </div>

          <div style={styles.papersCardDeck}>
            {allAvailablePapers.length === 0 ? (
              <div style={{ padding: '20px', textAlign: 'center', color: '#94a3b8', fontSize: '12.5px' }}>
                Please select a course to load syllabus papers.
              </div>
            ) : (
              allAvailablePapers.map((paper, idx) => {
                const isChecked = selectedPaperCodes.includes(paper.code);
                return (
                  <div
                    key={idx}
                    onClick={() => togglePaper(paper.code)}
                    style={{
                      ...styles.paperCheckRow,
                      background: isChecked ? '#eff6ff' : '#ffffff',
                      borderColor: isChecked ? '#bfdbfe' : '#e2e8f0'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      {isChecked ? <CheckSquare size={16} color="#2563eb" /> : <Square size={16} color="#94a3b8" />}
                      <span style={{ fontWeight: '700', color: '#1e40af', fontSize: '12.5px' }}>{paper.code}</span>
                      <span style={{ fontSize: '12.5px', color: '#334155' }}>{paper.title}</span>
                    </div>
                    <span style={styles.paperSemBadge}>{paper.semester}</span>
                  </div>
                );
              })
            )}
          </div>
        </div>

        {/* 10. TOTAL PAPERS SELECTED COUNT SUMMARY CARD */}
        <div style={styles.papersSummaryHighlightCard}>
          <div>
            <span style={{ fontSize: '11px', color: '#1e40af', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
              Application Paper Summary
            </span>
            <div style={{ fontSize: '13px', color: '#334155', fontWeight: '600', marginTop: '2px' }}>
              Course: <strong>{formCourseName}</strong> ({selectedSemesters.join(', ')})
            </div>
          </div>
          <div style={styles.selectedCountBadgeBox}>
            <span style={{ fontSize: '10px', color: '#64748b', textTransform: 'uppercase', fontWeight: '700' }}>Total Papers</span>
            <strong style={{ fontSize: '18px', color: '#1e40af', fontWeight: '900' }}>
              {selectedPaperCodes.length}
            </strong>
          </div>
        </div>

        {/* Status Dropdown (Edit Mode Only) */}
        {editingId && (
          <div style={styles.fieldContainer}>
            <label style={styles.fieldLabel}>Application Status</label>
            <select
              value={formStatus}
              onChange={(e) => setFormStatus(e.target.value)}
              style={styles.formSelect}
            >
              <option value="Submitted">Submitted</option>
              <option value="Approved">Approved</option>
              <option value="Rejected">Rejected</option>
            </select>
          </div>
        )}

        {/* Modal Action Buttons */}
        <div style={styles.formActionDock}>
          <button type="button" onClick={() => setIsFormModalOpen(false)} style={styles.formCancelBtn}>
            Cancel
          </button>
          <button type="submit" disabled={submitting} style={styles.formSaveBtn}>
            {submitting ? 'Processing...' : editingId ? 'Save Changes' : `Submit Application (${selectedPaperCodes.length} Papers)`}
          </button>
        </div>

      </form>
    </div>
  </div>
)}

      {/* ⚡ MODAL 2: VIEW APPLICANT FULL DETAILS */}
      {selectedApp && (
        <div style={styles.modalBackdrop}>
          <div style={styles.modalWrapperCard}>
            <div style={styles.modalHeader}>
              <div>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '800', color: '#0f172a' }}>
                  Examination Application Details
                </h3>
                <span style={{ fontSize: '12px', color: '#64748b' }}>
                  Application ID: #{selectedApp.id} • {formatDate(selectedApp.created_at)}
                </span>
              </div>
              <button onClick={() => setSelectedApp(null)} style={styles.modalCloseX}>
                <X size={18} />
              </button>
            </div>

            <div style={styles.modalBodyScroll}>
              {/* Applicant Summary */}
              <div style={styles.applicantInfoBanner}>
                <div style={styles.infoCol}>
                  <span style={styles.infoLabel}>Applicant Name</span>
                  <span style={styles.infoValue}>{selectedApp.student_name}</span>
                </div>
                <div style={styles.infoCol}>
                  <span style={styles.infoLabel}>Enrolment Number</span>
                  <span style={{ ...styles.infoValue, color: '#1e40af' }}>{selectedApp.enrolment_number}</span>
                </div>
                <div style={styles.infoCol}>
                  <span style={styles.infoLabel}>Gender / DOB</span>
                  <span style={styles.infoValue}>{selectedApp.gender || '-'} / {selectedApp.dob || '-'}</span>
                </div>
                <div style={styles.infoCol}>
                  <span style={styles.infoLabel}>Father's Name</span>
                  <span style={styles.infoValue}>{selectedApp.father_name || '-'}</span>
                </div>
                <div style={styles.infoCol}>
                  <span style={styles.infoLabel}>Mobile / WhatsApp</span>
                  <span style={styles.infoValue}>{selectedApp.mobile_number}</span>
                </div>
                <div style={styles.infoCol}>
                  <span style={styles.infoLabel}>Exam Centre</span>
                  <span style={styles.infoValue}>{selectedApp.examination_centre || selectedApp.study_centre_name || 'ALAGAPPA UNIVERSITY'}</span>
                </div>
              </div>

              {/* Course & Term Bar */}
              <div style={styles.courseMetaBar}>
                <div>
                  <span style={{ fontSize: '11px', color: '#64748b', textTransform: 'uppercase', fontWeight: '700' }}>Course Track</span>
                  <div style={{ fontSize: '14px', fontWeight: '800', color: '#0f172a' }}>{selectedApp.course_name}</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <span style={{ fontSize: '11px', color: '#64748b', textTransform: 'uppercase', fontWeight: '700' }}>Term & Session</span>
                  <div style={{ fontSize: '13px', fontWeight: '700', color: '#1e40af' }}>
                    {selectedApp.appearing_semester} ({selectedApp.exam_month_year})
                  </div>
                </div>
              </div>

              {/* Permanent Address */}
              {selectedApp.permanent_address ? (
                <div style={styles.addressBox}>
                  <span style={styles.infoLabel}>Permanent Address</span>
                  <div style={{ fontSize: '12.5px', color: '#334155', marginTop: '2px' }}>
                    {selectedApp.permanent_address}
                  </div>
                </div>
              ) : null}

              {/* Applied Subjects Table */}
              <div style={{ marginTop: '16px' }}>
                <span style={{ fontSize: '12px', fontWeight: '800', color: '#0f172a', textTransform: 'uppercase' }}>
                  Applied Subjects ({selectedApp.no_of_papers_appeared || 0} Papers)
                </span>
                <div style={styles.subjectsTableWrapper}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ background: '#f1f5f9' }}>
                        <th style={{ ...styles.subTh, width: '90px' }}>Sub Code</th>
                        <th style={styles.subTh}>Title of the Course Paper</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(() => {
                        let subs = [];
                        if (selectedApp.subjects_json) {
                          try {
                            subs = typeof selectedApp.subjects_json === 'string'
                              ? JSON.parse(selectedApp.subjects_json)
                              : selectedApp.subjects_json;
                          } catch (e) {
                            subs = [];
                          }
                        }
                        if (subs.length === 0) {
                          return (
                            <tr>
                              <td colSpan="2" style={{ padding: '12px', textAlign: 'center', color: '#94a3b8', fontSize: '12px' }}>
                                No specific subject papers attached.
                              </td>
                            </tr>
                          );
                        }
                        return subs.map((sub, idx) => (
                          <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                            <td style={{ padding: '8px 12px', fontWeight: '700', color: '#2563eb', fontSize: '12.5px' }}>
                              {sub.code}
                            </td>
                            <td style={{ padding: '8px 12px', color: '#334155', fontSize: '12.5px' }}>
                              {sub.title}
                            </td>
                          </tr>
                        ));
                      })()}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Close Button */}
            {/* Close & Print Buttons */}
<div style={styles.paymentSummaryRow}>
  <span style={{ fontSize: '12px', fontWeight: '700', color: '#059669' }}>
    Status: {selectedApp.status || 'Submitted'}
  </span>
  <div style={{ display: 'flex', gap: '8px' }}>
    {/* ➕ Download Form from View Modal */}
  <button
      type="button"
      onClick={() => handleDirectPrintApplication(selectedApp)}
      style={styles.modalPrintBtn}
    >
      <Printer size={14} /> Print Application
    </button>

    <button onClick={() => setSelectedApp(null)} style={styles.modalCloseBtn}>
      Close Window
    </button>
  </div>
</div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

// ⚡ DESIGN STYLES
const styles = {
  container: { width: '100%', boxSizing: 'border-box' },
  filterControlPanel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '16px',
    flexWrap: 'wrap',
  },
  searchWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    maxWidth: '380px',
    width: '100%',
  },
  searchIcon: { position: 'absolute', left: '12px', color: '#94a3b8' },
  tableSearchInput: {
    width: '100%',
    padding: '10px 12px 10px 38px',
    background: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '10px',
    color: '#0f172a',
    fontSize: '13px',
    outline: 'none',
  },
  addAppBtn: {
    background: 'linear-gradient(90deg, #e30504 0%, #a80302 100%)',
    border: 'none',
    borderRadius: '8px',
    color: '#fff',
    padding: '9px 16px',
    fontSize: '12.5px',
    fontWeight: '700',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    whiteSpace: 'nowrap'
  },
  exportExcelBtn: {
    background: '#0f172a',
    color: '#ffffff',
    border: 'none',
    padding: '9px 16px',
    borderRadius: '8px',
    fontSize: '12.5px',
    fontWeight: '700',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    whiteSpace: 'nowrap'
  },
  totalIndicator: { fontSize: '13.5px', fontWeight: '600', color: '#475569' },
  dataTable: { width: '100%', borderCollapse: 'collapse', textAlign: 'left', background: '#ffffff' },
  tableTh: {
    padding: '12px 14px',
    borderBottom: '2px solid #e2e8f0',
    background: '#f8fafc',
    color: '#64748b',
    fontSize: '11px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    fontWeight: '700',
    whiteSpace: 'nowrap',
  },
  tableTr: { borderBottom: '1px solid #f1f5f9' },
  tableTd: { padding: '13px 14px', color: '#475569', fontSize: '13px', verticalAlign: 'middle', whiteSpace: 'nowrap' },
  noDataTd: { padding: '40px 14px', textAlign: 'center', color: '#94a3b8', fontSize: '14px', fontWeight: '500' },
  termLabel: {
    background: '#eff6ff',
    border: '1px solid #bfdbfe',
    color: '#1e40af',
    padding: '3px 8px',
    borderRadius: '6px',
    fontSize: '11.5px',
    fontWeight: '700',
  },
  statusPill: { padding: '4px 10px', borderRadius: '12px', fontSize: '11px', fontWeight: '700', display: 'inline-block' },
  statusSubmitted: { background: '#fef3c7', color: '#92400e' },
  statusApproved: { background: '#d1fae5', color: '#065f46' },
  statusRejected: { background: '#fee2e2', color: '#991b1b' },
  actionIconButton: {
    background: '#f8fafc',
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    padding: '6px',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paginationDock: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '12px',
    marginTop: '16px',
    paddingTop: '12px',
    borderTop: '1px solid #edf2f7',
  },
  pageIndicator: { fontSize: '13px', color: '#475569' },
  pageBtn: {
    background: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    padding: '6px 14px',
    color: '#334155',
    fontSize: '12.5px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  pageBtnDisabled: { background: '#f8fafc', color: '#94a3b8', cursor: 'not-allowed', borderColor: '#e2e8f0' },
  
  // Modals
  modalBackdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(15, 23, 42, 0.45)',
    backdropFilter: 'blur(6px)',
    zIndex: 2000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  modalWrapperCard: {
    background: '#ffffff',
    borderRadius: '20px',
    width: '100%',
    maxWidth: '680px',
    maxHeight: '90vh',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    paddingBottom: '14px',
    borderBottom: '1px solid #e2e8f0',
  },
  modalCloseX: { background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer' },
  modalFormBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginTop: '14px',
    overflowY: 'auto',
    paddingRight: '4px'
  },
  modalBodyScroll: { overflowY: 'auto', marginTop: '14px', paddingRight: '4px' },
  formSplitGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
  formSplitGrid3: { display: 'grid', gridTemplateColumns: '1.2fr 1fr 1fr', gap: '10px' },
  fieldContainer: { display: 'flex', flexDirection: 'column', gap: '4px' },
  fieldLabel: { color: '#64748b', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.4px' },
  formInput: {
    width: '100%',
    padding: '9px 12px',
    background: '#f8fafc',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    color: '#0f172a',
    fontSize: '13px',
    outline: 'none',
    boxSizing: 'border-box'
  },
  formSelect: {
    width: '100%',
    padding: '9px 12px',
    background: '#f8fafc',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    color: '#0f172a',
    fontSize: '13px',
    outline: 'none',
    boxSizing: 'border-box'
  },
  checkboxPillsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px',
    marginTop: '2px'
  },
  semesterToggleChip: {
    border: '1px solid',
    borderRadius: '8px',
    padding: '5px 12px',
    fontSize: '12px',
    fontWeight: '700',
    cursor: 'pointer',
    transition: 'all 0.15s'
  },
  linkButton: {
    background: 'transparent',
    border: 'none',
    color: '#2563eb',
    fontSize: '11.5px',
    fontWeight: '700',
    cursor: 'pointer'
  },
  papersCardDeck: {
    border: '1px solid #e2e8f0',
    borderRadius: '10px',
    maxHeight: '160px',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    padding: '6px',
    background: '#f8fafc'
  },
  paperCheckRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '6px 10px',
    borderRadius: '6px',
    border: '1px solid',
    cursor: 'pointer'
  },
  paperSemBadge: {
    fontSize: '10.5px',
    fontWeight: '700',
    color: '#64748b',
    background: '#f1f5f9',
    padding: '2px 6px',
    borderRadius: '4px'
  },
  formActionDock: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginTop: '10px',
    paddingTop: '12px',
    borderTop: '1px solid #e2e8f0'
  },
  formCancelBtn: {
    background: '#f8fafc',
    border: '1px solid #e2e8f0',
    color: '#64748b',
    padding: '9px 16px',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  formSaveBtn: {
    background: '#2563eb',
    border: 'none',
    color: '#ffffff',
    padding: '9px 18px',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '700',
    cursor: 'pointer'
  },

  // View Modal
  applicantInfoBanner: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px',
    background: '#f8fafc',
    borderRadius: '12px',
    padding: '14px',
    border: '1px solid #e2e8f0',
  },
  infoCol: { display: 'flex', flexDirection: 'column' },
  infoLabel: { fontSize: '11px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase' },
  infoValue: { fontSize: '13px', fontWeight: '700', color: '#0f172a', marginTop: '2px' },
  courseMetaBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: '#eff6ff',
    border: '1px solid #bfdbfe',
    borderRadius: '12px',
    padding: '12px 14px',
    marginTop: '12px',
  },
  addressBox: {
    background: '#ffffff',
    borderRadius: '10px',
    padding: '12px',
    border: '1px solid #e2e8f0',
    marginTop: '12px',
  },
  subjectsTableWrapper: {
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    overflow: 'hidden',
    marginTop: '8px',
  },
  subTh: { padding: '8px 12px', textAlign: 'left', fontSize: '11px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase' },
  paymentSummaryRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '20px',
    paddingTop: '14px',
    borderTop: '1px solid #e2e8f0',
  },
  modalCloseBtn: {
    background: '#2563eb',
    border: 'none',
    color: '#ffffff',
    padding: '8px 18px',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '700',
    cursor: 'pointer',
  },
  studentSearchPickerBox: {
  background: '#f8fafc',
  border: '1px solid #cbd5e1',
  borderRadius: '12px',
  padding: '12px 14px',
  display: 'flex',
  flexDirection: 'column',
  gap: '6px'
},
inputWithIconBox: {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  width: '100%'
},
inlineSearchIcon: {
  position: 'absolute',
  left: '12px',
  color: '#94a3b8'
},
fieldInputWithIcon: {
  width: '100%',
  padding: '10px 36px 10px 36px',
  background: '#ffffff',
  border: '1px solid #cbd5e1',
  borderRadius: '8px',
  color: '#0f172a',
  fontSize: '13px',
  outline: 'none',
  boxSizing: 'border-box'
},
pickerClearBtn: {
  position: 'absolute',
  right: '12px',
  background: 'transparent',
  border: 'none',
  color: '#64748b',
  cursor: 'pointer',
  fontSize: '13px',
  fontWeight: '700'
},
studentSearchResultsDropdown: {
  position: 'absolute',
  top: '46px',
  left: 0,
  right: 0,
  background: '#ffffff',
  border: '1px solid #cbd5e1',
  borderRadius: '8px',
  maxHeight: '220px',
  overflowY: 'auto',
  zIndex: 100,
  boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.15)'
},
candidateResultItem: {
  padding: '10px 14px',
  borderBottom: '1px solid #f1f5f9',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  transition: 'background 0.15s ease'
},
univPill: {
  background: '#eff6ff',
  border: '1px solid #bfdbfe',
  color: '#1e40af',
  padding: '2px 8px',
  borderRadius: '6px',
  fontSize: '11px',
  fontWeight: '700'
},
papersSummaryHighlightCard: {
  background: '#eff6ff',
  border: '1px solid #bfdbfe',
  borderRadius: '12px',
  padding: '12px 16px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: '6px'
},
selectedCountBadgeBox: {
  background: '#ffffff',
  border: '1px solid #bfdbfe',
  borderRadius: '8px',
  padding: '4px 14px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
},
checkboxPillsContainer: {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '6px',
  marginTop: '4px'
},
semesterToggleChip: {
  border: '1px solid',
  borderRadius: '8px',
  padding: '6px 12px',
  fontSize: '12px',
  fontWeight: '700',
  cursor: 'pointer',
  transition: 'all 0.15s ease'
},
linkButton: {
  background: 'transparent',
  border: 'none',
  color: '#2563eb',
  fontSize: '12px',
  fontWeight: '700',
  cursor: 'pointer'
},
papersCardDeck: {
  border: '1px solid #e2e8f0',
  borderRadius: '10px',
  maxHeight: '160px',
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  padding: '6px',
  background: '#f8fafc'
},
paperCheckRow: {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px 10px',
  borderRadius: '6px',
  border: '1px solid',
  cursor: 'pointer'
},
paperSemBadge: {
  fontSize: '10.5px',
  fontWeight: '700',
  color: '#64748b',
  background: '#f1f5f9',
  padding: '2px 6px',
  borderRadius: '4px'
},
actionIconButton: {
  background: '#f8fafc',
  border: '1px solid #e2e8f0',
  borderRadius: '6px',
  padding: '6px',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center'
},
coursePillsContainer: {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',
  marginTop: '2px'
},
courseToggleChip: {
  border: '1px solid',
  borderRadius: '8px',
  padding: '7px 14px',
  fontSize: '12.5px',
  fontWeight: '700',
  cursor: 'pointer',
  transition: 'all 0.15s ease',
  display: 'inline-flex',
  alignItems: 'center'
},
pdfExportBtn: {
  background: '#0f172a',
  color: '#ffffff',
  border: 'none',
  padding: '9px 15px',
  borderRadius: '8px',
  fontSize: '12.5px',
  fontWeight: '700',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  whiteSpace: 'nowrap'
},
modalPrintBtn: {
  background: '#047857',
  border: 'none',
  color: '#ffffff',
  padding: '8px 16px',
  borderRadius: '8px',
  fontSize: '12.5px',
  fontWeight: '700',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px'
},
modalPrintBtn: {
  background: '#1e40af',
  color: '#ffffff',
  border: 'none',
  padding: '8px 16px',
  borderRadius: '8px',
  fontSize: '12.5px',
  fontWeight: '700',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  boxShadow: '0 2px 4px rgba(30, 64, 175, 0.2)',
  transition: 'all 0.15s ease'
}
};